import { HttpClient } from 'Mri.Web.Common';
import { Labels } from '../BI/BiStore';

export class LabelStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    public labelChartColor(label: string): string {
        switch (label) {
            case Labels.Offline:
                return '#90A4AE';
            case Labels.Good:
                return '#2d8ba3';
            case Labels.Critical:
                return '#ad1032';
            case Labels.Warning:
                return '#ffe503';
            case Labels.Playing:
                return '#2d8ba3';
            case Labels.NotPlaying:
                return '#ad1032';
        }
        return '#2d8ba3';
    }

    public labelCardColor(label: string) {
        switch (label) {
            default:
            case Labels.Offline:
                return 'gray';
            case Labels.Good:
                return 'teal';
            case Labels.Critical:
                return 'danger';
            case Labels.Warning:
                return 'warning';
            case Labels.Playing:
                return 'teal';
            case Labels.NotPlaying:
                return 'danger';
        }
    }

    public labelIcon(label: string) {
        switch (label) {
            default:
            case Labels.Offline:
                return 'bolt';
            case Labels.Good:
                return 'check-circle';
            case Labels.Critical:
                return 'bolt';
            case Labels.Warning:
                return 'exclamation-triangle';
            case Labels.Playing:
                return 'check-circle';
            case Labels.NotPlaying:
                return 'bolt';
        }
    }
    private readonly httpClient: HttpClient;
}
